var exports = {
  "p$": "FloatingPaneResizeHandles.module__handle___SF8yS1",
  "J3": "FloatingPaneResizeHandles.module__edgeTop___SF8yS1",
  "xf": "FloatingPaneResizeHandles.module__edgeBottom___SF8yS1",
  "Ve": "FloatingPaneResizeHandles.module__edgeLeft___SF8yS1",
  "IW": "FloatingPaneResizeHandles.module__edgeRight___SF8yS1",
  "wy": "FloatingPaneResizeHandles.module__cornerTopLeft___SF8yS1",
  "Ty": "FloatingPaneResizeHandles.module__cornerTopRight___SF8yS1",
  "AU": "FloatingPaneResizeHandles.module__cornerBottomLeft___SF8yS1",
  "pr": "FloatingPaneResizeHandles.module__cornerBottomRight___SF8yS1",
};

module.exports = exports;
